module.exports = __webpack_public_path__ + "static/media/pectineus_right_tension.b53a1023.png";